import { largeVideoModal, ModalVideo } from "../booths/common";

export const getColumn = (columnOffset = 6.4, width = 28) => {
    let curTop = 7

    return {
        getRow({height = 3.8, label, modal}) {
            const res = {
                width: `${width}%`,
                height: `${height}%`,
                left: `${columnOffset}%`,
                top: `calc(${curTop}% + 1px)`,
                modalOverrides: largeVideoModal,
                modal: <ModalVideo url={modal}/>,
                label
            }
            curTop = curTop + height;
            return res
        }
    }
}